/**
 * @author shaojingchao
 * @date 2020/4/20 14:45
 * @project zujuanzaixian
 * @description
 */
import _ from 'lodash'
import jsBase64 from 'js-base64'
import Md5 from 'crypto-js/md5'
import { isType } from './is-type'

const {Base64} = jsBase64
export const createReqID = (publicKey, params) => {
  let timestamp = new Date().getTime()
  return Base64.encode(Md5(timestamp + Md5('0' + publicKey).toString() + params).toString() + timestamp)
}

/**
 * 验证服务器响应数据是否被篡改
 */
export const validateRes = (reqid, resid, datastr, pub) => {
  let md5str = Md5(reqid + datastr + pub).toString()
  let result = md5str === resid
  if (!result) {
    console.log(datastr)
    console.warn('数据校验失败！')
  }
  return result
}

export const publicKey = '451680b3bda9fa7c'

export const addWatermark = (cfg) => {
  let reqData = cfg.data
  let reqDataStr = ''
  // 去除data和params种的空参数
  if (reqData) {
    reqDataStr = JSON.stringify(reqData)
    cfg.data = JSON.parse(reqDataStr)
    cfg.data = _.omitBy(cfg.data, (value, key) => {
      return empty(value)
    })
  }
  // 过滤 value === '' 的参数
  if (cfg.params) {
    // 过滤 value === '' 的参数
    let params = _.omitBy(cfg.params, (value) => {
      return empty(value)
    })
    cfg.params = paramVal2String(params)
  }

  // 请求参数加水印
  // post请求只处理 data
  // get请求只处理 params
  // 详细说明参考文档 https://www.showdoc.cc/487686466852539?page_id=2865466161942395
  let reqid = ''
  if (cfg.method === 'post' && reqDataStr) {
    reqid = createReqID(publicKey, reqDataStr)
  }
  if (cfg.method === 'get' && cfg.params) {
    reqid = createReqID(publicKey, JSON.stringify(cfg.params))
  }

  // 没有参数时也要添加水印，校验响应数据是否被修改
  if (!reqid) {
    reqid = createReqID(publicKey, JSON.stringify({}))
  }

  // 添加到当前请求配置中，该参数会传递到response 的 config 中，用于数据完整性校验
  cfg.requestid = reqid
  cfg.headers['client-reqid'] = reqid
}

// 是否为空
function empty (val) {
  return val === '' || val == null
}

/**
 * url params 参数值转字符串
 *
 */
function paramVal2String (params) {
  if (isType(params, 'object')) {
    _.forOwn(params, (val, key) => {
      params[key] = paramVal2String(val)
    })
    return params
  } else if (isType(params, 'array')) {
    return _.map(params, (item) => {
      return paramVal2String(item)
    })
  } else if (isType(params, 'number')) {
    return String(params)
  } else if (isType(params, 'string')) {
    return params
  } else if (params == null) {
    return ''
  } else {
    return params
  }
}
